import loginedApi from "../apis";
import { FETCH_APPOINTMENT_HISTORY, FETCH_SELECTED_APPOINTMENT_DETAILS } from "./type";
import specialist from "../specialityList";
import authHeader from './auth-header';
import CryptoJS from "crypto-js";
  var hashcode = CryptoJS.SHA256(process.env.REACT_APP_PREFIX+process.env.REACT_APP_TOKEN+process.env.REACT_APP_SECRETKEY);

const publicIp = require("public-ip");
let IP = publicIp.v4();
const { detect } = require('detect-browser');
const browser = detect();
let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;
let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B")
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D")
}//replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`




export const validateOtp = ({key,otpvalue}) => async (dispatch) => {
    // let data 
    // axios.get('https://ipapi.co/json/').then((response) => {
    //      data = response.data;
    //     console.log(data)
       
    //   //  setCounty(data.country_name)

    // }).catch((error) => {
    //     console.log(error);
    // });
    console.log(key)
    const res = await loginedApi.post("validateotp", {
        requestType: 580,
   token :hashcode.toString(),
        data: { key: key.includes("%2B")?key.trim():key,
            otpvalue: otpvalue,
            browserTimeZone: `GMT${formatTime}`,
            Browser: browser.name+" "+browser.version,
            appname: "C2MD Web",
            useragent: userAgent,
           },
      });

/* const res = await loginedApi.post("validateOtp",
        {
            "requestType": "580",
            token :hashcode.toString(),
            "version":"2.0",
            "data": {
                key: key,
                otpvalue: otpvalue,
                browserTimeZone: `GMT${formatTime}`,
                Browser: browser.name+" "+browser.version,
                appname: "C2MD Web",
                useragent: userAgent,
            }
        }
    ); */

  //const res = await loginedApi.post("updatereports",formdata ,{ headers: authHeader() });

  console.log("validateOtp",res);


  if (res.status === 200) {
      
      
      return res

  }
};



export const getCountryCode = () => async (dispatch) => {
  let res = await loginedApi.post("getcountrycode", {
    token: hashcode.toString(),
    version: "2.0",
    data: { browserTimeZone: `GMT${formatTime}` },
    requestType: 1058,
  });

console.log("validateOtp",);


if (res.status === 200) {
    
    
    return res.data.data

}
};

export const passcodelogin = (passCode) => async (dispatch) => {
  
  console.log(passCode)
  const res = await loginedApi.post("passcodelogin", {
      requestType: 32,
      token :hashcode.toString(),
      data: { 
          Otp: passCode,
          browserTimeZone: `GMT${formatTime}`,
          Browser: browser.name+" "+browser.version,
          appname: "C2MD Web",
          useragent: userAgent,
         },
    });
console.log("passcode login",res);


if (res.status === 200) {
    
    
    return res

}
};
